export class scrollMenu {
    constructor () {
        window.addEventListener('scroll', function() {
            var element = document.querySelector('#video');

            if ( element ) {
                var position = element.getBoundingClientRect();

                if (position.top >= 0 && position.bottom <= window.innerHeight) {
                    document.body.classList.remove("active");
                } else if (position.top < window.innerHeight && position.bottom >= 180) {
                    document.body.classList.remove("active");
                } else {
                    document.body.classList.add("active");
                }
            }
        }, {
            capture: true
        });
    }
}